import React from 'react';
import { FormattedDate } from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'moment';

/**
 * Formata um Label, com base no locale 
 * selecionado na classe principal
 * @param {Date} props.date a ser formatada
 * @author Fábio Sartori
 * @copyright 06/2019
 */
const DateLabel = ( props ) => (

    (props.full) ? 
        <FormattedDate value={moment(props.date).toDate()} 
            year="numeric"
            month="long"
            day="2-digit"
            weekday="long"
        />
    : (props.dayMouth) ? 
        <FormattedDate value={moment(props.date).toDate()} 
            month="2-digit"
            day="2-digit"
        />
    :
        <FormattedDate value={moment(props.date).toDate()} 
            year="numeric"
            month="2-digit"
            day="2-digit"
        />

);
export default DateLabel;

DateLabel.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    full: PropTypes.bool
}